import React, { useState } from "react";
import {
  Button,
  Grid,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import mgmtVariantOptions from "src/services/mgmtVariantOptions";

const VariantOptionsEditForm = ({ data }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [name, setName] = useState(data?.name || "");
  const [values, setValues] = useState(
    data?.values?.length ? data.values : [""]
  );

  const handleValueChange = (index, value) => {
    const updatedValues = [...values];
    updatedValues[index] = value;
    setValues(updatedValues);
  };

  const handleAddValue = () => {
    setValues([...values, ""]);
  };

  const handleRemoveValue = (index) => {
    if (values.length === 1) return;

    setValues(values.filter((_, i) => i !== index));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const filteredValues = values.filter(
      (value) => value.trim() !== ""
    );

    const payload = {
      customerId: Number(data?.customerId),
      variationId: Number(data?.variationId),
      name: name.trim(),
      values: filteredValues,
    };
    try {
      await mgmtVariantOptions.updateVariantOption(payload);

      enqueueSnackbar(
        "Variant Option updated successfully",
        {
          variant: "success",
        }
      );

      navigate("/app/management/variant-options");

    } catch (error) {
      enqueueSnackbar(
        "Failed to update Variant Option",
        {
          variant: "error",
        }
      );
    }
  };

  return (
  <form onSubmit={handleSubmit}>
    <Grid container spacing={3}>

      {/* Customer ID */}
      <Grid item xs={14} md={6}>
        <TextField
          fullWidth
          size="small"
          label="Customer ID"
          value={data?.customerId || ""}
          disabled
        />
      </Grid>

      {/* Variation ID */}
      <Grid item xs={14} md={6}>
        <TextField
          fullWidth
          size="small"
          label="Variation ID"
          value={data?.variationId || ""}
          disabled
        />
      </Grid>

      {/* Name */}
<Grid item xs={12}>
    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        size="small"
        label="Name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </Grid>
</Grid>
{/* Values */}
<Grid item xs={18}>
  <Grid
    container
    alignItems="center"
    justifyContent="space-between"
    sx={{ mb: 2 }}
  >
    <Grid item>
      <Typography variant="body2">
        VALUES
      </Typography>
    </Grid>

    <Grid item>
      <Button
        type="button"
        startIcon={<AddIcon />}
        onClick={handleAddValue}
        size="small"
      >
        ADD VALUE
      </Button>
    </Grid>
  </Grid>

  {values.map((value, index) => (
    <Grid
      container
      spacing={1}
      alignItems="center"
      key={index}
      sx={{ mb: 1.5 }}
    >
      <Grid item xs>
        <TextField
          fullWidth
          size="small"
          label={`Value ${index + 1}`}
          value={value}
          onChange={(event) =>
            handleValueChange(index, event.target.value)
          }
        />
      </Grid>

      <Grid item>
        <IconButton
          color="error"
          onClick={() => handleRemoveValue(index)}
          disabled={values.length === 1}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  ))}
</Grid>

      {/* Buttons */}
      <Grid item xs={12}>
        <Button
          type="submit"
          variant="contained"
        >
          UPDATE
        </Button>

        <Button
          type="button"
          sx={{ ml: 2 }}
          onClick={() =>
            navigate("/app/management/variant-options")
          }
        >
          CANCEL
        </Button>
      </Grid>

    </Grid>
  </form>
);
};

export default VariantOptionsEditForm;